import { createContext, useContext } from "react";
import type Keycloak from "keycloak-js";
import { keycloak as defaultKeycloak } from "./keycloak";

/**
 * Provider 컴포넌트와 분리(비컴포넌트 모듈)해야 React Fast Refresh 가 정상 동작한다.
 */
export interface KeycloakContextValue {
  keycloak: Keycloak;
  initialized: boolean;
}

export type KeycloakEventType =
  | "onReady"
  | "onAuthSuccess"
  | "onAuthError"
  | "onAuthRefreshSuccess"
  | "onAuthRefreshError"
  | "onAuthLogout"
  | "onTokenExpired";

export const KeycloakContext = createContext<KeycloakContextValue>({
  keycloak: defaultKeycloak,
  initialized: false
});

export function useKeycloak(): KeycloakContextValue {
  return useContext(KeycloakContext);
}
